<template>
  <div class="finance-page">
    <header class="finance-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('moneybag.rechargeRecord') }}</h1>
    </header>

    <main class="finance-main">
      <section
        v-if="listShow"
        class="empty-card"
      >
        <van-empty :description="$t('item.noData')" />
      </section>

      <section
        v-if="data && data.length"
        class="record-list"
      >
        <article
          v-for="(item, index) in data"
          :key="item.id || item.orderid || item.time || index"
          class="record-card"
        >
          <div class="record-head">
            <div class="record-title">
              <strong>{{ $t('invest_qrcode.recharge') }}</strong>
              <span v-if="item.orderid">{{ item.orderid }}</span>
            </div>
            <b
              class="record-price"
              :class="item.status =='1'?'add':item.status =='2'?'del':''"
            >
              {{ utils_moneyMark() }}{{ item.money }}
            </b>
          </div>

          <div class="record-meta">
            <span
              v-if="item.status =='0'||item.status =='3'"
              class="status-pill pending"
            >
              {{ $t('invest_qrcode.submittedSuccessfully') }}
            </span>
            <span
              v-if="item.status =='1'"
              class="status-pill success"
            >
              {{ $t('invest.success') }}
            </span>
            <span
              v-if="item.status =='2'"
              class="status-pill failed"
            >
              {{ $t('invest.failed') }}
            </span>
            <time>{{ formatBrowserTime(item.time) }}</time>
          </div>

          <p
            v-if="item.memo!=null"
            class="record-memo"
          >
            {{ $t('cash.remark') }}: {{ item.memo }}
          </p>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
        Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "RechargeRecord",
        data() {
            return {
                lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 1
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.mymoney = r.data.mymoney;
                this.funds = r.data.money;
                this.userName = r.data.username;
            });
            Fetch('/user/recharge_search').then(r=>{
                this.showError(r.data.length);
                this.data = r.data;
            })
        },
        methods: {
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
.finance-page {
    min-height: 100vh;
    background: #f4f5fb;
    color: #061429;
}

.finance-header {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fd;
}

.finance-header h1 {
    margin: 0;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
}

.back-btn {
    position: absolute;
    left: 8px;
    top: 10px;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #071426;
    font-size: 22px;
}

.finance-main {
    padding: 16px 16px 88px;
}

.empty-card,
.record-card {
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.record-card {
    padding: 16px 18px;
}

.record-card + .record-card {
    margin-top: 12px;
}

.record-head,
.record-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
}

.record-title {
    min-width: 0;
}

.record-title strong,
.record-price {
    display: block;
    overflow: hidden;
    color: #050b18;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-title span {
    display: block;
    margin-top: 4px;
    overflow: hidden;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-price {
    flex: 0 0 auto;
    max-width: 42%;
    margin-left: 12px;
    color: #9aa2b1;
    text-align: right;
}

.record-price.add {
    color: #ff4551;
}

.record-price.del {
    color: #38bf62;
}

.record-meta {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #edf0f6;
}

.status-pill {
    max-width: 58%;
    overflow: hidden;
    padding: 5px 9px;
    border-radius: 999px;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.status-pill.pending {
    background: #ff9f2e;
}

.status-pill.success {
    background: #38bf62;
}

.status-pill.failed {
    background: #8f98a8;
}

.record-meta time {
    margin-left: 12px;
    overflow: hidden;
    color: #687083;
    font-size: 12px;
    line-height: 18px;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-memo {
    margin: 10px 0 0;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
}
</style>
